import _defineProperty from 'babel-runtime/helpers/defineProperty';
import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import classNames from 'classnames';

var Checkbox = {

  mixins: [BaseMixin],
  props: {
    prefixCls: PropTypes.string,
    checked: PropTypes.bool,
    indeterminate: PropTypes.bool
  },
  methods: {
    onCheck: function onCheck(e) {
      this.__emit('change', e);
    }
  },

  render: function render() {
    var _classNames;

    var h = arguments[0];
    var _$props = this.$props,
        prefixCls = _$props.prefixCls,
        checked = _$props.checked,
        indeterminate = _$props.indeterminate;
    var onCheck = this.onCheck;


    var checkboxProps = {
      attrs: {
        'class': classNames((_classNames = {}, _defineProperty(_classNames, prefixCls + '-checkbox', true), _defineProperty(_classNames, prefixCls + '-checkbox-checked', checked), _defineProperty(_classNames, prefixCls + '-checkbox-indeterminate', indeterminate), _classNames))
      },
      on: {
        click: onCheck
      }
    };
    return (
      /* 2022/1/24 替换checkbox样式提高性能 */
      h('span', checkboxProps)
    );
  }
};

export default Checkbox;